"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__usedConstrctionFunc = exports.constructLDFeatureSwitch = exports.withFeatureSwitch = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const ldClient_1 = require("./ldClient");
const util_1 = require("./util");
const enhancer_1 = require("./enhancer");
/**
 *
 *
 * @template T
 * @param {string} clientSideId
 *  Launch darkly client side id
 * @param {T} [initialFeatureSwitches]
 *  Initial feature switches
 * @param {LDFeatureSwitchesConfig} [config={ hotReload: true, waitForReady: true }]
 *
 *  hotReload[default true]: if true, when receive feature flag change, will instantly update app
 *
 *  waitForReady[default true]: whether wait for launch darkly ready, usually it takes 200ms, according to launch darkly docs
 * @param {LDOptions} [ldClientOption]
 *  Launch darkly client options
 * @param {string} [userIdentifier]
 *  to setup launch darkly user
 * @return {*}  {Promise}
 */
const withFeatureSwitch = async (clientSideId, initialFeatureSwitches, config = {
    hotReload: true,
    waitForReady: true,
    showLog: false,
}, ldClientOption, userIdentifier) => {
    const ld = ldClient_1.FlagManager.init(clientSideId, { showLog: config.showLog }, ldClientOption, userIdentifier);
    const _initialFeatureSwitches = util_1.validateFeatureSwitches(initialFeatureSwitches || {});
    return enhancer_1.createEnhancer(ld, _initialFeatureSwitches, context_1.FeatureSwitchProvider, config);
};
exports.withFeatureSwitch = withFeatureSwitch;
let __usedConstrctionFunc = false;
exports.__usedConstrctionFunc = __usedConstrctionFunc;
const DEFAULT_CONFIG = {
    hotReload: true,
    waitForReady: true,
    showLog: false,
    proxy: {
        enable: true,
        baseUrl: util_1.LAUNCH_DARKLY_PROXY_URL,
    },
};
const mixWithDefaultConfig = (config) => ({
    ...DEFAULT_CONFIG,
    ...config,
    proxy: {
        ...DEFAULT_CONFIG.proxy,
        ...config.proxy,
    },
});
const constructLDFeatureSwitch = (clientSideId, initialFeatureSwitches, _config, ldClientOption, userIdentifier) => {
    exports.__usedConstrctionFunc = __usedConstrctionFunc = true;
    const config = mixWithDefaultConfig(_config);
    const proxyOptions = config.proxy?.enable
        ? {
            baseUrl: config.proxy.baseUrl + "/app",
            eventsUrl: config.proxy.baseUrl + "/events",
        }
        : undefined;
    const ld = ldClient_1.FlagManager.init(clientSideId, { showLog: config.showLog }, { ...proxyOptions, ...ldClientOption }, userIdentifier);
    const _initialFeatureSwitches = util_1.validateFeatureSwitches(initialFeatureSwitches || {});
    const ctx = context_1.createContext();
    const { Provider } = ctx;
    const useFeatureFlag = (featureName) => {
        const { featureSwitches } = react_1.useContext(ctx);
        return featureSwitches?.[featureName];
    };
    const useFeatureSwitches = () => {
        const { featureSwitches } = react_1.useContext(ctx);
        return featureSwitches;
    };
    const useFeatureSwitchContext = () => {
        return react_1.useContext(ctx);
    };
    const useIdentifyUser = () => {
        const { flagManager } = react_1.useContext(ctx);
        return (userId, payload) => flagManager.identifyUser(userId, payload);
    };
    const enhancer = enhancer_1.createEnhancer(ld, _initialFeatureSwitches, Provider, config);
    return {
        enhancer,
        FeatureSwitchContext: ctx,
        useFeatureFlag,
        useFeatureSwitches,
        useFeatureSwitchContext,
        useIdentifyUser,
    };
};
exports.constructLDFeatureSwitch = constructLDFeatureSwitch;
